// import { useWindowSize } from 'react-use';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
function useScreenSize() {
    return '1440';
}

function useIsMobile() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

    return isMobile;
    // const { width } = useWindowSize();
    // return width < theme.breakpoints.values.lg;
}

export { useScreenSize, useIsMobile };
